import classnames from 'classnames';
import { useHasAccess } from 'lib-shared-access-control';
import { ampli } from 'lib-shared-tracking';
import { useMount } from 'react-use';

import { useAppSelector } from 'utils/redux/useAppSelector';
import { trialLengthInDays, useCopilotTrial } from 'utils/useCopilotTrial';

import { TopbarButtonOld } from '../topbar/components/topbarButtonOld';

import './styles/beamer-button.less';

type BeamerButtonProps = {
  className?: string;
};

export const BeamerButton = ({ className }: BeamerButtonProps): JSX.Element => {
  const { profile, organization } = useAppSelector((state) => ({
    profile: state.settings.profile.profile,
    organization: state.settings.organization.organization,
  }));
  const { trialDaysLeft } = useCopilotTrial();
  const useHasOrganizationInfo = useHasAccess('organization.info');

  useMount(() => {
    const { id, email, name } = profile;
    const { created_at } = organization;
    const nameArr = name ? name.split(/\s+/) : [];
    const filters = [useHasOrganizationInfo ? 'admin' : 'agent'];
    if (trialDaysLeft !== null) {
      const dayOfTrial = trialLengthInDays - trialDaysLeft + 1;
      filters.push(`copilotTrialDay${dayOfTrial}`);
    }
    window.beamer_config.user_id = id;
    window.beamer_config.filter = filters.join(';');
    window.beamer_config.user_email = email;
    window.beamer_config.organization_created_at = created_at;
    window.beamer_config.user_firstname = nameArr.shift();
    window.beamer_config.user_lastname = nameArr.join(' ');
    if (window.Beamer) {
      window.Beamer.init();
    } else {
      window.beamer_config.callback = () => {
        window.Beamer.init();
      };
    }
  });

  const rootClass = classnames('pull-right', className);

  return (
    <TopbarButtonOld
      id="topbar-beamer"
      tooltip="What's new"
      className={rootClass}
      onClick={() => {
        window.Beamer.show();
        ampli.topbarBeamerOpened();
      }}
      icon="gift"
    />
  );
};
